import produce from 'immer';
import { SILENT_RENEW_ERROR, USER_EXPIRED } from 'redux-oidc';
import { ActionTypes } from './App.actions';

export const initialState = {
    userData: {},
    oidcSilentRenewError: false,
};
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.loadUserCompleted: {
            const { userData } = action.payload;
            draft.userData = userData;
            return draft;
        }
        case USER_EXPIRED:
        case SILENT_RENEW_ERROR: {
            draft.oidcSilentRenewError = true;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
